import React from 'react';
import MainLayout from '../layouts/MainLayout';
import Hero from '../components/Hero';
import SocialProofBar from '../components/SocialProofBar';
import RevenueProposition from '../components/RevenueProposition';
import ZeroRisk from '../components/ZeroRisk';
import Product from '../components/Product';
import HowItWorks from '../components/HowItWorks';
import NetworkEffects from '../components/NetworkEffects';
import CaseData from '../components/CaseData';
import Faq from '../components/Faq';
import CTA from '../components/CTA';

const Home = () => {
  return (
    <MainLayout>
      <Hero />
      <SocialProofBar />
      <RevenueProposition />
      <ZeroRisk />
      <Product />
      <HowItWorks />
      <NetworkEffects />
      <CaseData />
      <Faq />
      <CTA />
    </MainLayout>
  );
};

export default Home;
